import { gunterzBold } from '@/theme/fonts';
import { Box, Image, Paper, Text } from '@mantine/core';
export type VipClubWorkCardProps = {
  imgUrl: string;
  title: string;
  description: string;
};
export const VipClubWorkCard: React.FC<VipClubWorkCardProps> = ({
  imgUrl,
  title,
  description
}) => {
  return <Paper px={{
    base: 10,
    lg: 48
  }} pt={{
    base: 84,
    lg: 120
  }} pb={{
    base: 24,
    lg: 30
  }} radius={5} bg="var(--input-variant-color)" pos="relative">
      <Image src={imgUrl} alt="how-it-work" w={117} h={117} mx="auto" pos="absolute" inset="-24px 0 auto 0" />
      <Box mt={{
      base: 24,
      lg: 0
    }}>
        <Text ta="center" fz={{
        base: 'sm',
        sm: 'lg'
      }} c="var(--text-prime)" className={gunterzBold.className}>
          {title}
        </Text>
        <Text fz={{
        base: 'sm',
        sm: 'xs'
      }} c="var(--text-dark)" ta="center">
          {description}
        </Text>
      </Box>
    </Paper>;
};